import { BuildingOffice2Icon } from "@heroicons/react/24/outline";
import { SidebarItem, SidebarLabel } from "components/layout/sidebar";
import { useGetUserTenantRegionOptionsQuery } from "generated/graphql";
import * as React from "react";
import { useRegionId } from "store/selectors/hooks";
import { stableQueryOptions } from "util/requests";

export const NgRegionToggle: React.FC = () => {
    const query = useGetUserTenantRegionOptionsQuery({}, stableQueryOptions());
    const currentRegionId = useRegionId();

    if (query.isLoading || !query.data) {
        return null;
    }

    if (query.data.getUserTenantRegionOptions.options.length <= 1) {
        return null;
    }

    const multipleTenantsAvailable =
        query.data.getUserTenantRegionOptions.options
            .map(o => o.tenantId)
            .reduce((acc, cur) => acc.add(cur), new Set()).size > 1;

    const currentRegion = query.data.getUserTenantRegionOptions.options.find(
        o => o.regionId === currentRegionId,
    );

    const currentRegionName = currentRegion ? currentRegion.regionName : "Unknown";
    const currentTenantName = currentRegion ? currentRegion.tenantName : "Unknown";

    const displayText = multipleTenantsAvailable
        ? `${currentTenantName}: ${currentRegionName}`
        : currentRegionName;

    return (
        <SidebarItem href="/office" current={false}>
            <BuildingOffice2Icon />
            <SidebarLabel>
                <div className="uppercase text-[10px] text-zinc-500">office</div>
                <div>{displayText}</div>
            </SidebarLabel>
        </SidebarItem>
    );
};
